import { render, staticRenderFns } from "./Resume.vue?vue&type=template&id=5981ce00&scoped=true&"
import script from "./Resume.vue?vue&type=script&lang=js&"
export * from "./Resume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5981ce00",
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import QSpinnerBars from 'quasar/src/components/spinner/QSpinnerBars.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QPage,QSpinnerBars,QCard,QCardSection});
